import { Plus, X } from "lucide-react";
import { L } from "@/i18n";

const LETTERS = "ABCDEFGH";

export const OptionsEditor = ({ options, correct, onChange, onCorrect, locked, inputCls }) => {
  const setAt = (i, v) => onChange(options.map((o, j) => (j === i ? v : o)));
  const remove = (i) => {
    onChange(options.filter((_, j) => j !== i));
    if (correct === i) onCorrect(0);
    else if (correct > i) onCorrect(correct - 1);
  };

  return (
    <div className="space-y-2" data-testid="edit-question-options">
      {options.map((opt, i) => (
        <div key={i} className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => onCorrect(i)}
            aria-pressed={correct === i}
            title={L("Mark as correct answer", "Marcar como resposta correta")}
            data-testid={`edit-question-correct-${i}`}
            className={`h-9 w-9 shrink-0 rounded-md border font-mono text-xs transition-colors ${
              correct === i ? "border-emerald-500 bg-emerald-500/15 text-emerald-300" : "border-slate-700 text-slate-500 hover:border-emerald-500/60"
            }`}
          >
            {LETTERS[i]}
          </button>
          <input className={inputCls} value={opt} onChange={(e) => setAt(i, e.target.value)} data-testid={`edit-question-option-${i}`} />
          {!locked && options.length > 2 && (
            <button type="button" onClick={() => remove(i)} className="p-2 text-slate-500 hover:text-rose-400" data-testid={`edit-question-remove-option-${i}`} aria-label={L("Remove option", "Remover opção")}>
              <X className="h-4 w-4" />
            </button>
          )}
        </div>
      ))}
      {!locked && options.length < LETTERS.length && (
        <button type="button" onClick={() => onChange([...options, ""])} className="flex items-center gap-1.5 text-xs text-amber-400 hover:text-amber-300" data-testid="edit-question-add-option">
          <Plus className="h-3.5 w-3.5" /> {L("Add option", "Adicionar opção")}
        </button>
      )}
      <p className="text-[11px] text-slate-500">{L("Click a letter to mark the correct answer.", "Clique numa letra para marcar a resposta correta.")}</p>
    </div>
  );
};
